// extracted by mini-css-extract-plugin
export default {"page":"ycUvP","inner":"FsDlI","title":"Knp56","main":"odt7j","swiper":"pKgDt","question":"ma93C","answers":"ucO0G","emptyAnswers":"OJ9Hk","actions":"G45Ta"};